module.exports = __webpack_public_path__ + "static/media/patterns-ss.84370f99.png";